import { type CardType } from '@atlaskit/linking-common';

export const getMarkName: any = (id: string, status: CardType) => `${status}:${id}`;
